// extracted by mini-css-extract-plugin
export default {"container":"StatusIcon_container__gcfK9","icon":"StatusIcon_icon__zUEOm"};